import React from 'react';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Problems } from './components/Problems';
import { BrandReveal } from './components/BrandReveal';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { CountdownSection } from './components/CountdownSection';
import { Pricing } from './components/Pricing';
import { UpsellTeaser } from './components/UpsellTeaser';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-ink" data-id="element-0" data-mp="28u5zysgmvffh">
      <TopBar data-id="element-1" data-mp="28t4lsf4bmctj" />
      <Hero data-id="element-2" data-mp="28sl32w6ujkeg" />
      <main data-id="element-3" data-mp="28sb9kymlev40">
        <SocialProof data-id="element-4" data-mp="23vciyq2516ak" />
        <Problems data-id="element-5" data-mp="23vupqgmff2wq" />
        <BrandReveal data-id="element-6" data-mp="23u9v6r043jyv" />
        <Volumes data-id="element-7" data-mp="23ut9lxqjzq85" />
        <Bonuses data-id="element-8" data-mp="23t8eo70bu59r" />
        <CountdownSection data-id="element-9" data-mp="3ijxsv0nzqion" />
        <Pricing data-id="element-10" data-mp="3ikqwvtvkeu33" />
        <UpsellTeaser data-id="element-11" data-mp="3ij61y35c994p" />
        <Testimonials data-id="element-12" data-mp="3ihv2ugmu8pjx" />
        <Guarantee data-id="element-13" data-mp="3mlj6wpc9h30f" />
        <Faq data-id="element-14" data-mp="3mkrd9k285fcs" />
        <FinalCta data-id="element-15" data-mp="3mkho1yp07c85" />
      </main>
      <Footer data-id="element-16" data-mp="3mjpyp5m02aqb" />
    </div>;
}